<template>
  <!-- 详细题型设置 中-->
  <div class="typesetting">
    
    
    <!--答题设置-->
    <div class="answer_set">
      <p class="limit" @click="basicSetOpen = !basicSetOpen">
        <span class="limit_ys" ></span> 
		<a name="basicSet">基本设置</a> 
		<i v-if="basicSetOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="basicSetOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>考试开始时间</span>
            <el-switch
              v-model="basicForm.startTimeState"
              :active-value="1"
              :inactive-value="0"
              @change="startTimeSwitch"
            />
          </li>
          <li v-if="basicForm.startTimeState == 1" class="limit_num_box">
            <el-date-picker
                v-model="basicForm.startTimeValue"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="startTimeChange"
                type="datetime"
                placeholder="选择考试开始时间">
                </el-date-picker>
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>考试结束时间 </span>
            <el-switch
              v-model="basicForm.endTimeState"
              :active-value="1"
              :inactive-value="0"
              @change="endTimeSwitch"
            />
          </li>
          <li v-if="basicForm.endTimeState == 1" class="limit_num_box">
            <el-date-picker
                v-model="basicForm.endTimeValue"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="endTimeChange"
                type="datetime"
                placeholder="选择考试结束时间">
                </el-date-picker>
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>开启时间倒计时 </span>
            <el-switch
              v-model="basicForm.countDownState"
              :active-value="1"
              :inactive-value="0"
                @change="countDownChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p class="list_title">
                考试结束超过
                <el-input
                    class="list_title_item_input"
                    size="mini"
                    type="number"
                    v-model.number="basicForm.overtimeValue" 
                    @blur="overtimeBlur"
                    :disabled="!basicForm.overtimeState"
                ></el-input>
                秒 没有新操作就强制交卷 </p>
            <el-switch
                v-model="basicForm.overtimeState"
                :active-value="1"
                :inactive-value="0"
                @change="overtimeSwitch"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>
              断点续答
              <el-tooltip content="记录答题进度，下次可继续作答" placement="top" effect="light">
                <i class="el-icon-question" style=" color: #ccc; cursor: pointer;"></i>
              </el-tooltip>
            </p>
            <el-switch
              v-model="basicForm.continueState"
              :active-value="1"
              :inactive-value="0"
                @change="continueChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>答题密码</p>
            <el-switch
                v-model="basicForm.passwordState"
                :active-value="1"
                :inactive-value="0"
                @change="passwordChange"
            />
          </li>
          <li v-if="basicForm.passwordState == 1" class="limit_num_box">
            <div class="input_box">
                <el-input 
                    ref="passwordVal"
                    :class="{'input__err': basicForm.passwordErr}"
                    placeholder="请输入密码" 
                    v-model="basicForm.passwordValue" 
                    show-password
                    @blur="passwordBlur"
                ></el-input>
                <div v-show="basicForm.passwordErr" class="form-item__error">请输入密码</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--提交后显示-->
    <div class="answer_set">
      <p class="limit" @click="submitOpen = !submitOpen">
        <span class="limit_ys" ></span> 
		<a name="submitSet">提交后显示</a> 
		<i v-if="submitOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="submitOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>显示成绩单</span>
            <el-switch
              v-model="submitForm.reportCardState"
              :active-value="1"
              :inactive-value="0"
              @change="reportCardChange"
            />
          </li>
        </ul>
        <!-- <ul class="answer_set_ul ">
          <li class="button_line">
            <span>显示感谢信息</span>
            <el-switch
                v-model="submitForm.thankInfoState"
                :active-value="1"
                :inactive-value="0"
                @change="thankInfoChange"
            />
          </li>
          <li v-if="submitForm.thankInfoState == 1" class="limit_num_box">
            <div class="input_box">
                <el-input 
                    placeholder="请输入感谢信息" 
                    v-model="submitForm.thanksContent" 
                    @blur="thankInfoBlur"
                ></el-input>
            </div>
          </li>
        </ul> -->
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>显示排行榜</span>
            <el-switch
              v-model="submitForm.rankingListState"
              :active-value="1"
              :inactive-value="0"
                @change="rankingListChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>可查看正确答案和解析</span>
            <el-switch
              v-model="submitForm.viewAnswersState"
              :active-value="1"
              :inactive-value="0"
                @change="viewAnswersChange"
            />
          </li>
        </ul>
       
      </div>
    </div>
    <!--微信设置-->
    <div class="answer_set">
      <p class="limit" @click="vxOpen = !vxOpen">
        <span class="limit_ys" ></span> 
		<a name="wxSet">微信设置</a> 
		<i v-if="vxOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="vxOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>只允许从微信中填写</span>
            <el-switch
              v-model="vxForm.onlyVXState"
              :active-value="1"
              :inactive-value="0"
              @change="onlyVXChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <span>获取微信用户的昵称（需登录）</span>
            <el-switch
              v-model="vxForm.getVXUsernameState"
              :active-value="1"
              :inactive-value="0"
              @change="getVXUsernameChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <div class="list_title">
                每个微信答题次数限制
            </div>
            <el-switch
                v-model="vxForm.answerOnceState"
                :active-value="1"
                :inactive-value="0"
                @change="answerOnceChange"
            />
          </li>
          <li v-if="vxForm.answerOnceState == 1" class="limit_num_box">
            <div class="input_box">
              同一微信只能作答
                <el-input 
                    class="list_title_item_input"
                    size="mini"
                    type="number"
                    v-model.number="vxForm.answerOnceValue" 
                    @blur="answerOnceBlur"
                    :disabled="!vxForm.answerOnceState"
                ></el-input>
                次
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--答题限制-->
    <div class="answer_set">
      <p class="limit" @click="answerOpen = !answerOpen">
        <span class="limit_ys" ></span> 
		<a name="answerSet">答题限制</a> 
		<i v-if="answerOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="answerOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <div class="list_title">
                每台电脑或手机答题次数限制
            </div>
            <el-switch
              v-model="answerForm.PCMTState"
              :active-value="1"
              :inactive-value="0"
              @change="PCMTChange"
            />
          </li>
          <li v-if="answerForm.PCMTState == 1" class="limit_num_box">
            <div class="input_box">
              同一电脑或手机只能作答
                <el-input
                    class="list_title_item_input"
                    size="mini"
                    type="number"
                    v-model.number="answerForm.PCMTValue" 
                    @blur="PCMTBlur"
                    :disabled="!answerForm.PCMTState"
                ></el-input>
                次
            </div>
          </li>
        </ul>
        <ul class="answer_set_ul ">
            
          <li class="button_line">
            <div class="list_title">
                每个IP答题次数限制
            </div>
            <el-switch
              v-model="answerForm.IPState"
              :active-value="1"
              :inactive-value="0"
              @change="IPChange"
            />
          </li>
          <li v-if="answerForm.IPState == 1" class="limit_num_box">
            <div class="input_box">
              同一IP只能作答
              <el-input 
                  class="list_title_item_input"
                  size="mini"
                  type="number"
                  v-model.number="answerForm.IPValue" 
                  @blur="IPBlur"
                  :disabled="!answerForm.IPState"
              ></el-input>
              次
            </div>
          </li>
        </ul>
        <!-- <ul class="answer_set_ul ">
          <li class="button_line">
            <p>允许提交答卷前预览答卷</p>
            <el-switch
              v-model="answerForm.previewState"
              :active-value="1"
              :inactive-value="0"
              @change="previewChange"
            />
          </li>
        </ul> -->
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>控制提交答卷总数</p>
            <el-switch
              v-model="answerForm.subNumState"
              :active-value="1"
              :inactive-value="0"
              @change="subNumChange"
            />
          </li>
          <li v-if="answerForm.subNumState == 1" class="limit_num_box">
            收集
            <el-input 
                class="list_title_item_input"
                size="mini"
                type="number"
                v-model.number="answerForm.subNum" 
                @blur="subNumBlur"
                :disabled="!answerForm.subNumState"
            ></el-input>
            份数据时结束
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>隐藏答题者来源详情、IP地址信息(适用于要求匿名的场景，开启后不允许再取消)</p>
            <el-switch
              v-model="answerForm.hideInfoState"
              :active-value="1"
              :inactive-value="0"
              :disabled="answerForm.hideInfoState == 1"
              @change="hideInfoChange"
            />
          </li>
        </ul>
      </div>
    </div>
    <!--题目设置-->
    <div class="answer_set">
      <p class="limit" @click="topicsOpen = !topicsOpen">
        <span class="limit_ys" ></span> 
		<a name="topicsSet">题目设置</a> 
		<i v-if="topicsOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="topicsOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>显示系统题目序号</p>
            <el-switch
              v-model="topicsForm.serialNumState"
              :active-value="1"
              :inactive-value="0"
              @change="topicsChange"
            />
          </li>
        </ul>
      </div>
    </div>
    <!--答题页显示设置-->
    <div class="answer_set">
      <p class="limit" @click="isShowOpen = !isShowOpen">
        <span class="limit_ys" ></span> 
		<a name="isShowSet">答题页显示设置</a> 
		<i v-if="isShowOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="isShowOpen">
        <!-- <ul class="answer_set_ul ">
          <li class="button_line">
            <p>中英文显示
            <el-radio-group
                @change="languageChange"
                v-model="isShowForm.languageValue"
                :disabled="!isShowForm.languageState"
                style="margin-left: 30px;"
                 >
                <el-radio :label="1" :value="1">中文</el-radio>
                <el-radio :label="2" :value="2">英文</el-radio>
            </el-radio-group>
            </p>
            
            <el-switch
              v-model="isShowForm.languageState"
              :active-value="1"
              :inactive-value="0"
              @change="languageChange"
            />
          </li>
        </ul> -->
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>显示进度条</p>
            <el-switch
              v-model="isShowForm.isShowProgressState"
              :active-value="1"
              :inactive-value="0"
              @change="isShowProgressChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>
              每次打开均为新答题页
              <el-tooltip content="与‘断点续答’" placement="top" effect="light">
                <i class="el-icon-question" style=" color: #ccc; cursor: pointer;"></i>
              </el-tooltip>
            </p>
            <el-switch
              v-model="isShowForm.newPageState"
              :active-value="1"
              :inactive-value="0"
              @change="newPageChange"
            />
          </li>
        </ul>
      </div>
    </div>
    <!--分享设置-->
    <!-- <div class="answer_set">
      <p class="limit" @click="shareOpen = !shareOpen">
        <span class="limit_ys" ></span> 
		<a name="shareSet">分享设置</a> 
		<i v-if="shareOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="shareOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>问卷内容</p>
          </li>
          <li class="limit_num_box">
            <div class="button_line_box">
              <el-select 
                  class="button_line_item"
                  size="mini" 
                  v-model="shareForm.copyValue" 
                  placeholder="请选择"
              >
                  <el-option
                      v-for="item in copyoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
              </el-select>
              <el-select
                  class="button_line_item"
                  size="mini"
                  v-model="shareForm.detectionValue" 
                  placeholder="请选择"
              >
                  <el-option
                      v-for="item in detectionoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
              </el-select>
              <i class="el-icon-question button_line_item"></i>
              <el-button 
                  class="button_line_item" 
                  type="primary" 
                  size="mini"
                  @click="contentSubmit"
                  >保存</el-button>
            </div>
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>统计分析</p>
            <el-switch
              v-model="shareForm.analysisState"
              :active-value="1"
              :inactive-value="0"
              @change="analysisChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>对外查询</p>
            <el-switch
              v-model="shareForm.queryState"
              :active-value="1"
              :inactive-value="0"
              @change="queryChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>允许共享为模板</p>
            <el-switch
              v-model="shareForm.shareTemplateState"
              :active-value="1"
              :inactive-value="0"
              @change="shareTemplateChange"
            />
          </li>
        </ul>
      </div>
    </div> -->
    <!--防作弊设置-->
    <div class="answer_set">
      <p class="limit" @click="antiCheatingOpen = !antiCheatingOpen">
        <span class="limit_ys" ></span> 
		<a name="antiCheatingSet">防作弊设置</a> 
		<i v-if="antiCheatingOpen != true" class="el-icon-arrow-right limit_icon"></i>
		<i v-else class="el-icon-arrow-down limit_icon2"></i>
      </p>
      <div v-show="antiCheatingOpen">
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>随机抽题</p>
            <div>
              <el-button 
                v-if="antiCheatingForm.randomState == 1" 
                style="margin-right: 10px;" 
                type="text" 
                @click="selectionSetting"
              >设置</el-button>
              <el-switch
                v-model="antiCheatingForm.randomState"
                @change="randomChange"
                :active-value="1"
                :inactive-value="0"
              />
            </div>
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <p>所有题目重新排列(仅对同一页问题随机排列)</p>
            <el-switch
              v-model="antiCheatingForm.rearrangeState"
              :active-value="1"
              :inactive-value="0"
              @change="rearrangeChange"
            />
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line ">
            <p>防作弊里面增加根据IP白名单答题</p>
            <el-switch
              v-model="antiCheatingForm.whiteListState"
              :active-value="1"
              :inactive-value="0"
              @change="whiteListChange"
            />
          </li>
          <li class="limit_num_box" v-if="antiCheatingForm.whiteListState == 1">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="50000"
              show-word-limit
              placeholder="每行一个名单"
              @blur="whiteListBlur"
              v-model="antiCheatingForm.whiteListValue">
            </el-input>
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <div class="list_title">
                答题超时设置
                
            </div>
            <el-switch
                v-model="antiCheatingForm.timeoutState"
                :active-value="1"
                :inactive-value="0"
                @change="timeoutChange"
            />
          </li>
          <li class="limit_num_box" v-if="antiCheatingForm.timeoutState == 1">
            答题超过
              <el-input 
                  class="list_title_item_input"
                  size="mini"
                  type="number"
                  v-model.number="antiCheatingForm.timeoutValue"
                  @blur="timeoutBlur"
                  :disabled="!antiCheatingForm.timeoutState"
              ></el-input>
            秒 没有新操作就强制交卷 
          </li>
        </ul>
        <ul class="answer_set_ul ">
          <li class="button_line">
            <div class="list_title">
                <p>
                  切屏设置
								<el-tooltip placement="top" effect="light">
                  <div slot="content">
                    注意事项:<br/>
                    1.为防止误触，系统允许的最少切屏次数为1次，无法完全禁止。<br/>
                    2.手机作答过程中，上传文件、接打电话、查看短信或上传附件等系统行为均会被记为切屏，请酌情设置合理次数。<br/>
                    3.本功能无法限制手机“分屏模式”，在PC端对部分老旧浏览器（如IE10及以下）不兼容。
                  </div>
									<i class="el-icon-question" style=" color: #ccc;cursor: pointer;"></i>
								</el-tooltip>
                </p>
            </div>
            <el-switch
                v-model="antiCheatingForm.cutScreenState"
                :active-value="1"
                :inactive-value="0"
                @change="cutScreenChange"
            />
          </li>
          <li class="limit_num_box" v-if="antiCheatingForm.cutScreenState == 1">
            允许切屏
            <el-input 
                class="list_title_item_input"
                size="mini"
                type="number"
                v-model.number="antiCheatingForm.cutScreenValue"
                @blur="cutScreenBlur"
                :disabled="!antiCheatingForm.cutScreenState"
            ></el-input>
            次 超出该次数会取消继续作答权限
          </li>
        </ul>
      </div>
    </div>
    <div class="release-box" v-if="examState == 1 && showBtn == 1">
      <el-button type="primary" size="medium" @click="$router.push({path: '/sendTest'})">发布项目</el-button>
    </div>
    <el-dialog
      title="随机抽题设置"
      :visible.sync="randomDialogVisible"
      width="50%"
      :append-to-body="true" :close-on-click-modal="false">
      <div v-if="antiCheatingForm.randomState == 1">
          <el-radio-group v-model="antiCheatingForm.randomValue">
              <el-radio :label="1" :value="1">按题目</el-radio>
              <el-radio :label="2" :value="2">按分页</el-radio>
              <el-radio :label="3" :value="3">按题型</el-radio>
          </el-radio-group>
          <div v-if="antiCheatingForm.randomValue == 1">
            <div>
              <div class="ques_title_box " v-for="(item, index) in antiCheatingForm.quesArr" :key="index">
                  从题目
                  <el-select 
                    class="list_title_item_input" 
                    v-model="item.beginQid" 
                    :popper-append-to-body="false"
                    placeholder="请选择"
                  >
                  <template v-for="(val, quesIndex) in questionsList">
                    <el-option
                      :key="val.qid"
                      v-if="index > 0 && quesIndex >= questionsList.findIndex((el) => el.qid == antiCheatingForm.quesArr[index-1].endQid) + 1 || index == 0"
                      :label="$functions.htmlFormat(val.questionsName)"
                      :value="val.qid"
                      :disabled="val.disabled"
                    >
                      {{$functions.htmlFormat(val.questionsName)}}
                    </el-option>
                  </template>
                  </el-select>
                  到题目
                  <el-select 
                    class="list_title_item_input" 
                    v-model="item.endQid"
                    :popper-append-to-body="false"
                    placeholder="请选择"
                  >
                    <template v-for="(val, quesIndex) in questionsList">
                      <el-option
                        v-if="quesIndex >= questionsList.findIndex((el) => el.qid == item.beginQid)"
                        :key="val.qid"
                        :label="$functions.htmlFormat(val.questionsName)"
                        :value="val.qid"
                        :disabled="index < antiCheatingForm.quesArr.length -1 && quesIndex >= questionsList.findIndex((el) => el.qid == antiCheatingForm.quesArr[index+1].beginQid)"
                      >
                        {{$functions.htmlFormat(val.questionsName)}}
                      </el-option>
                    </template>
                  </el-select>
                  中随机抽取
                  <div class="input_box">
                    <el-input 
                      :class="{'input__err': item.isError}" 
                      class="list_title_item_input"  
                      size="mini" 
                      type="number" 
                      v-model.number="item.number" 
                      
                      ></el-input>
                    <div v-show="item.isError" class="form-item__error">该范围有{{item.max}}道题</div>
                  </div>
                  道题
                  <i @click="deleteQuesArr(index)" v-if="index != 0" class="el-icon-delete delete-icon"></i>
                </div>
                
              
              <div>
                <el-button class="max-btn" @click="addquesArr">增加设置</el-button>
              </div>
              <div>
                <el-button class="submit-btn" type="primary" size="small" @click="randomSubmit">保存</el-button>
              </div>
              
            </div>
          </div>
          <div v-else-if="antiCheatingForm.randomValue == 2">
            <div class="ques_page_box">
                  从分页
                  <el-input class="list_title_item_input" size="mini" type="number" v-model.number="antiCheatingForm.randomArr.begin" ></el-input>
                  到分页
                  <el-input class="list_title_item_input" size="mini" type="number" v-model.number="antiCheatingForm.randomArr.end" ></el-input>
                  中随机抽取
                  <div class="input_box">
                    <el-input 
                      :class="{'input__err': antiCheatingForm.randomArr.isError}" 
                      class="list_title_item_input"  
                      size="mini" 
                      type="number" 
                      v-model.number="antiCheatingForm.randomArr.number" 
                      
                      ></el-input>
                    <div v-show="antiCheatingForm.randomArr.isError" class="form-item__error">共{{antiCheatingForm.randomArr.page}}页</div>
                  </div>
                  个分页
              </div>
              <div class="tips">
                <p>提示：</p>
                <p>每页的题目数不一致，分页随机后题目总数无法确认</p>
              </div>
              <div>
                <el-button class="submit-btn" type="primary" size="small" @click="randomSubmit">保存</el-button>
              </div>
          </div>
          <div v-else-if="antiCheatingForm.randomValue == 3">
            <div class="ques_type_box">
              <div  class="ques_title_box" v-if="questionTypeNum.radio > 0">
                在{{questionTypeNum.radio}}个单选题中随机抽取
                <div class="input_box">
                  <el-input 
                    :class="{'input__err': questionTypeNumIsErr.radio}" 
                    class="list_title_item_input"  
                    size="mini" 
                    type="number" 
                    v-model.number="antiCheatingForm.type1Num" 
                    
                    ></el-input>个题目
                  <div v-show="questionTypeNumIsErr.radio" class="form-item__error">共{{questionTypeNum.radio}}题</div>
                </div>
              </div>
              <div class="ques_title_box" v-if="questionTypeNum.checkbox > 0">
                在{{questionTypeNum.checkbox}}个多选题中随机抽取
                <div class="input_box">
                  <el-input 
                    :class="{'input__err': questionTypeNumIsErr.checkbox}" 
                    class="list_title_item_input"  
                    size="mini" 
                    type="number" 
                    v-model.number="antiCheatingForm.type2Num" 
                    
                    ></el-input>个题目
                  <div v-show="questionTypeNumIsErr.checkbox" class="form-item__error">共{{questionTypeNum.checkbox}}题</div>
                </div>
              </div>
              <div class="ques_title_box" v-if="questionTypeNum.judgement > 0">
                在{{questionTypeNum.judgement}}个判断题中随机抽取
                <div class="input_box">
                  <el-input 
                    :class="{'input__err': questionTypeNumIsErr.judgement}" 
                    class="list_title_item_input"  
                    size="mini" 
                    type="number" 
                    v-model.number="antiCheatingForm.type3Num" 
                    
                    ></el-input>个题目
                  <div v-show="questionTypeNumIsErr.judgement" class="form-item__error">共{{questionTypeNum.judgement}}题</div>
                </div>
              </div>
              <div class="ques_title_box" v-if="questionTypeNum.completion > 0">
                在{{questionTypeNum.completion}}个填空题中随机抽取
                <div class="input_box">
                  <el-input 
                    :class="{'input__err': questionTypeNumIsErr.completion}" 
                    class="list_title_item_input"  
                    size="mini" 
                    type="number" 
                    v-model.number="antiCheatingForm.type4Num" 
                    
                    ></el-input>个题目
                  <div v-show="questionTypeNumIsErr.completion" class="form-item__error">共{{questionTypeNum.completion}}题</div>
                </div>
              </div>
              <div class="ques_title_box" v-if="questionTypeNum.shortAnswer > 0">
                在{{questionTypeNum.shortAnswer}}个简答题中随机抽取
                <div class="input_box">
                  <el-input 
                    :class="{'input__err': questionTypeNumIsErr.shortAnswer}" 
                    class="list_title_item_input"  
                    size="mini" 
                    type="number" 
                    v-model.number="antiCheatingForm.type5Num" 
                    
                    ></el-input>个题目
                  <div v-show="questionTypeNumIsErr.shortAnswer" class="form-item__error">共{{questionTypeNum.shortAnswer}}题</div>
                </div>
              </div>
            </div>
            <div>
              <el-button class="submit-btn" type="primary" size="small" @click="randomSubmit">保存</el-button>
            </div>
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { mapState } from "vuex";
export default {
    name: 'ExamTypeSetting',
    props: {
      showBtn: { type: Number, default: 1 },
    },
  data() {
    return {
        id: '', // 考试id
        szTypeList: [
            {
            id: 1,
            title: "基本设置",
            icon: "",
            icon1: "",
            href: "basicSet",
            name: "basicSet",
            },
            {
            id: 2,
            title: "提交后显示",
            icon: "",
            icon1: "",
            href: "submitSet",
            name: "submitSet",
            },
            {
            id: 3,
            title: "微信设置",
            icon: "",
            icon1: "",
            href: "wxSet",
            name: "wxSet",
            },
            {
            id: 4,
            title: "答题限制",
            icon: "",
            icon1: "",
            href: "answerSet",
            name: "answerSet",
            },
            {
            id: 5,
            title: "题目设置",
            icon: "",
            icon1: "",
            href: "topicsSet",
            name: "topicsSet",
            },
            {
            id: 6,
            title: "答题页显示设置",
            icon: "",
            icon1: "",
            href: "isShowSet",
            name: "isShowSet",
            },
            // {
            // id: 7,
            // title: "分享设置",
            // icon: "",
            // icon1: "",
            // href: "shareSet",
            // name: "shareSet",
            // },
            {
            id: 8,
            title: "防作弊设置",
            icon: "",
            icon1: "",
            href: "antiCheatingSet",
            name: "antiCheatinget",
            },
        ],
        basicSetOpen: true,
        basicForm: {},
        submitOpen: true,
        submitForm: {},
        vxOpen: true,
        vxForm: {},
        answerOpen: true,
        answerForm: {},
        topicsOpen: true,
        topicsForm: {},
        isShowOpen: true,
        isShowForm: {},
        shareOpen: true,
        shareForm: {
          detectionValue: 0,
          copyValue: 0
        },
        antiCheatingOpen: true,
        antiCheatingForm: {
          randomState: 0,
          randomValue: 1,
          timeoutValue: 0,
          timeoutState: 0,
          cutScreenValue: 0,
          cutScreenState: 0,
          whiteListValue: '',
          quesArr: [],
          randomArr: {
            begin: 1,
            end: 1,
            number: 0,
            isError: false,
            page: 0
          },
          type1Num: 0,
          type2Num: 0,
          type3Num: 0,
          type4Num: 0,
          type5Num: 0,
        },
        copyoptions: [
            {
                value: 0,
                label: '不允许复制问卷'
            },{
                value: 1,
                label: '允许复制问卷'
            }
        ],
        detectionoptions: [
          {
              value: 0,
              label: '不屏蔽搜索引擎检测'
          },
          {
              value: 1,
              label: '屏蔽搜索引擎检测'
          },
            
        ],
        examState: 1,
        titleList: [], // 按题目可选题
        questionsList: [], // 总题目
        questionPages: 0, // 试卷分页数
        questionTypeNum: {
          radio: 0,
          checkbox: 0,
          judgement: 0,
          completion: 0,
          shortAnswer: 0
        },
        questionTypeNumIsErr: {
          radio: false,
          checkbox: false,
          judgement: false,
          completion: false,
          shortAnswer: false,
        },
        randomDialogVisible: false,
        tipMessage: '设置成功'
    };
  },
  computed:{
		...mapState(['examQuestionTypeArr']),
	},
  mounted: function() {
    let that = this;
    var winHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    this.height = winHeight - 108;
    this.rightheight = winHeight - 60;
    window.onresize = () => {
      var winHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      this.height = winHeight - 108;
      this.rightheight = winHeight - 60;
    };

    // that.wid = sessionStorage.getItem("wid") || 0;
    // if (that.wid == 0) {
    //   this.wjadd();
    // } else {
    //   sessionStorage.setItem("wid", that.wid);
    //   this.wjinfo();
    // }
  },
  created() {
    // this.token();
    this.id = sessionStorage.getItem("examId")
    this.getData()
    // this.getcheat()
    // this.getQuesNum()
    this.getQuestion()
   
  },
  methods: {
    deleteQuesArr(index) {
      this.antiCheatingForm.quesArr.splice(index, 1)
    },
    async randomSubmit() {
      if (this.antiCheatingForm.randomValue == 1){
        let max = 0
        let result = false
        this.antiCheatingForm.quesArr.forEach((el, arrIndex) =>{
          this.questionsList.forEach((info, index) => {
            max++
            if (info.qid == el.beginQid){
              max = 1
            }else if(info.qid == el.endQid) {
              el.max = max
              if (max < el.number) {
                el.isError = true
                result = true
              } else {
                el.isError = false
                result = false
              }
            }
          })
        })
        if (result == false) {
          let arr = []
          this.antiCheatingForm.quesArr.forEach((info, index) => {
            let data = {
              beginQid: info.beginQid,
              endQid: info.endQid,
              extractType: this.antiCheatingForm.randomValue,
              id: this.id,
              number: info.number,
            }
            arr.push(data)
          })
          // console.log(arr)
          // console.log('成功')
          // return
          this.randomDialogVisible = false
          this.submitRandom(arr)
        }
      } else if (this.antiCheatingForm.randomValue == 2) {
        let arr = []
        this.antiCheatingForm.randomArr.id = this.id
        this.antiCheatingForm.randomArr.extractType = this.antiCheatingForm.randomValue

        if (this.antiCheatingForm.randomArr.page < this.antiCheatingForm.randomArr.number) {
          this.antiCheatingForm.randomArr.isError = true
        } else {
          this.antiCheatingForm.randomArr.isError = false
          arr.push({
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            number: this.antiCheatingForm.randomArr.number,
            begin: this.antiCheatingForm.randomArr.begin,
            end: this.antiCheatingForm.randomArr.end,
          })
          // console.log(arr)
          // console.log('成功')
          this.submitRandom(arr)
          this.randomDialogVisible = false
        }
        
      } else {
        let arr = [
          {
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            answerType: 100,
            number: this.antiCheatingForm.type1Num
          },
          {
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            answerType: 101,
            number: this.antiCheatingForm.type2Num
          },
          {
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            answerType: 102,
            number: this.antiCheatingForm.type3Num
          },
          {
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            answerType: 204,
            number: this.antiCheatingForm.type4Num
          },
          {
            id: this.id,
            extractType: this.antiCheatingForm.randomValue,
            answerType: 206,
            number: this.antiCheatingForm.type5Num
          }
          
        ]
        
        let result = false
        arr.forEach((info, index) => {
          switch(info.answerType) {
            case 100:
              if (info.number > this.questionTypeNum.radio){
                this.questionTypeNumIsErr.radio = true
                result = true
              } else {
                this.questionTypeNumIsErr.radio = false
              }
              break
            case 101:
              if (info.number > this.questionTypeNum.checkbox){
                this.questionTypeNumIsErr.checkbox = true
                result = true
              } else {
                this.questionTypeNumIsErr.checkbox = false
              }
              break
            case 102:
              if (info.number > this.questionTypeNum.judgement){
                this.questionTypeNumIsErr.judgement = true
                result = true
              } else {
                this.questionTypeNumIsErr.judgement = false
              }
              break
            case 204:
              if (info.number > this.questionTypeNum.completion){
                this.questionTypeNumIsErr.completion = true
                result = true
              } else {
                this.questionTypeNumIsErr.completion = false
              }
              break
            case 206:
              if (info.number > this.questionTypeNum.shortAnswer){
                this.questionTypeNumIsErr.shortAnswer = true
                result = true
              } else {
                this.questionTypeNumIsErr.shortAnswer = false
              }
              break
          }
        })
        
        if (result == false) {
          // console.log(arr)
          // console.log('成功')
          this.submitRandom(arr)
          this.randomDialogVisible = false
        }
      }
    },
    // 获取试题题目与类型
    getQuestion() {
      let that = this
			let params = {
				that: this,
				url: `${this.$config.service.examPaperpreview}?id=${this.id}`,
				method: "POST",
				cb(res) {
					// console.log(res)
					let data = JSON.parse(res.resultBody.tbExamPaper.paperjson)
          that.titleList = []
          data.questionsList.forEach((info, index) => {
            if(that.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
              that.titleList.push(info)
              that.questionsList.push(info)
            } else if (info.questionsTypeId == 402 || info.questionsTypeId == 404){
              // console.log(info.questionsTypeId)
              that.questionPages++
            }
            switch(info.questionsTypeId){
              case 100:
                that.questionTypeNum.radio++
                break
              case 101:
                that.questionTypeNum.checkbox++
                break
              case 102:
                that.questionTypeNum.judgement++
                break
              case 204:
                that.questionTypeNum.completion++
                break
              case 206:
                that.questionTypeNum.shortAnswer++
                break
            }
          })
          // console.log(that.questionPages)
          that.antiCheatingForm.randomArr.end = that.antiCheatingForm.randomArr.page = that.questionPages + 1
          // console.log(that.antiCheatingForm)
				},
			};
			this.$util.request(params);
    },
    // 获取不同类型的试题数量
    getQuesNum() {
      let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examstopCheatfindCountTextType}?surveyId=${this.id}`,
            method: "POST",
            cb(res) {
              // console.log(res)
            },
        };
        this.$util.request(params);
    },
    selectionSetting() {
      this.getcheat()
      this.randomDialogVisible = true
    },
    getcheat(){
      let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examstopCheatfindBySurveyId}?surveyId=${this.id}`,
            method: "POST",
            cb(res) {
              that.antiCheatingForm.quesArr = []
              that.antiCheatingForm.randomArr = {}
                if (res.length > 0) {
                    that.antiCheatingForm.randomState = 1
                    that.antiCheatingForm.randomValue = res[0].extractType
                    res.forEach((info) => {
                      if (info.extractType == 1) {
                        // console.log(info)
                        that.antiCheatingForm.quesArr.push(info)
                      }else if(info.extractType == 2){
                        that.antiCheatingForm.randomArr = info
                      }else {
                        if (info.answerType == 100) {
                          that.antiCheatingForm.type1Num = info.number
                        } else if (info.answerType == 101){
                          that.antiCheatingForm.type2Num = info.number
                        } else {
                          that.antiCheatingForm.type3Num = info.number
                        }
                      }
                  })
                }
            },
        };
        this.$util.request(params);
    },
    getData() {
      let that = this
      let params = {
        that: this,
        url: `${this.$config.service.examProjectQueryById}?id=${this.id}`,
        method: "GET",
        cb(res) {
          // console.log(res)
          that.examState = res.resultBody.tbExamProject.state
          that.$emit('getExamState', res.resultBody.tbExamProject.state)
          that.basicForm = {
            startTimeValue: res.resultBody.tbExamProject.examStartTime,
            startTimeState: res.resultBody.tbExamProject.examStartStatus,
            endTimeState: res.resultBody.tbExamProject.examEndStatus,
            endTimeValue: res.resultBody.tbExamProject.examEndTime,
            countDownState: res.resultBody.tbExamProject.openReverseTimeStatus,
            overtimeValue: res.resultBody.tbExamProject.examrExceedTime,
            overtimeState: res.resultBody.tbExamProject.overtimeForceSubmit,
            continueState: res.resultBody.tbExamProject.saveLastContent,
            passwordState: res.resultBody.tbExamProject.answerPasswordStatus,
            passwordValue: res.resultBody.tbExamProject.answerPassword
          }
          that.submitForm = {
            reportCardState: res.resultBody.tbExamProject.showGradeBill,
            thankInfoState: res.resultBody.tbExamProject.showThankMessage,
            thanksContent: res.resultBody.tbExamProject.thanksContent ? res.resultBody.tbExamProject.thanksContent : '您的答卷已提交，感谢参与',
            rankingListState: res.resultBody.tbExamProject.showRanking,
            viewAnswersState: res.resultBody.tbExamProject.findResultParse,

          }
          that.vxForm = {
            onlyVXState: res.resultBody.tbExamProject.onlyWxAnswer,
            getVXUsernameState: res.resultBody.tbExamProject.getWxName,
            answerOnceState: res.resultBody.tbExamProject.wxAnswerNumState,
            answerOnceValue: res.resultBody.tbExamProject.wxAnswerNum,
          }
          that.answerForm = {
            PCMTValue: res.resultBody.tbExamProject.pcPhoneAnswerNum,
            PCMTState: res.resultBody.tbExamProject.pcPhoneAnswerNumState,
            IPValue: res.resultBody.tbExamProject.ipRestrictNum,
            IPState: res.resultBody.tbExamProject.ipRestrictNumState,
            previewState: res.resultBody.tbExamProject.allowBeforePreview,
            subNumState: res.resultBody.tbExamProject.setAnswerLimitState,
            subNum: res.resultBody.tbExamProject.setAnswerLimitNum,
            hideInfoState: res.resultBody.tbExamProject.hideInfo,
          }
          that.topicsForm.serialNumState = res.resultBody.tbExamProject.showTitleNum
          that.isShowForm = {
            isShowProgressState: res.resultBody.tbExamProject.showSchedule,
            newPageState: res.resultBody.tbExamProject.ifNewAnswerPage,
          }
          if (res.resultBody.tbExamProject.language == 0) {
            that.$set(that.isShowForm, 'languageState', 0)
          } else {
            that.$set(that.isShowForm, 'languageValue', res.resultBody.tbExamProject.language)
            that.$set(that.isShowForm, 'languageState', 1)
          }
          that.shareForm = {
            copyValue: res.resultBody.tbExamProject.questionnairePower,
            detectionValue: res.resultBody.tbExamProject.searchPower,
            analysisState: res.resultBody.tbExamProject.countAnalyse,
            queryState: res.resultBody.tbExamProject.externalFind,
            shareTemplateState: res.resultBody.tbExamProject.shareTemplate,

          }
          that.antiCheatingForm.rearrangeState = res.resultBody.tbExamProject.titleRealign
          that.antiCheatingForm.whiteListState = res.resultBody.tbExamProject.ipWhitelistStopCheat
          that.antiCheatingForm.timeoutValue = res.resultBody.tbExamProject.answerExceedTime
          that.antiCheatingForm.timeoutState = res.resultBody.tbExamProject.answerExceedState
          that.antiCheatingForm.cutScreenValue = res.resultBody.tbExamProject.cutScreenNum
          that.antiCheatingForm.cutScreenState = res.resultBody.tbExamProject.cutScreenStatus

          if (res.resultBody.tbExamIpLists  && res.resultBody.tbExamIpLists.length > 0) {
            let arr = []
            res.resultBody.tbExamIpLists.forEach((info) => {
              arr.push(info.ip)
            })
            that.antiCheatingForm.whiteListValue = arr.join('\n')
          }

          that.$set(that.antiCheatingForm, 'randomValue', 1)
          if (that.antiCheatingForm.quesArr.length == 0) {
            that.$set(that.antiCheatingForm, 'quesArr', [{
              beginQid: '',
              endQid: '',
              number: 0,
              max: 0,
              isError: false
            }])
          }
      
          that.antiCheatingForm.randomState = res.resultBody.tbExamProject.questionRandomState
          const {wxShareContent, wxSharePicture, wxShareTitle, title} = res.resultBody.tbExamProject
          that.$emit('getWXshare', 
          {
            wxShareContent: wxShareContent,
            wxSharePicture: wxSharePicture ? wxSharePicture : that.$logo,
            wxShareTitle: wxShareTitle,
            title: title
          })
        },
      };
      this.$util.request(params)
    },
    addquesArr() {
      if(this.antiCheatingForm.quesArr.length > 0) {
        if (!this.antiCheatingForm.quesArr[this.antiCheatingForm.quesArr.length - 1].endQid) {
          this.$message({
            message: '请选择结束题目',
            type: 'warning'
          });
          return
        }
      }
      let obj = {
        beginQid: '',
        endQid: '',
        number: 0,
        max: 0,
        isError: false
      }
      if (this.antiCheatingForm.quesArr.length > 0) {
        let index = this.questionsList.findIndex((info)=> info.qid == this.antiCheatingForm.quesArr[this.antiCheatingForm.quesArr.length -1].endQid)
        if (this.questionsList.length >= index + 1) obj.beginQid = this.questionsList[index+1].qid
      } else if (this.questionsList.length > 0) {
        obj.beginQid = this.questionsList[0].qid
      }
      this.antiCheatingForm.quesArr.push(obj)
    },
    
    // 基本设置start
    submitBasic(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectBasicSetup}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                    that.$message.success(that.tipMessage);
                } else{
                    that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    async startTimeSwitch(){
        if (this.basicForm.startTimeState === 0) {
            this.basicForm.startTimeValue = ''
            let data = {
                id: this.id,
                examStartStatus: this.basicForm.startTimeState,
                examStartTime: this.basicForm.startTimeValue,
            }
            this.tipMessage = this.basicForm.startTimeState == 0 ? '取消设置' : '设置成功'
            // console.log(this.tipMessage)
            await this.submitBasic(data)
        }
    },
    async startTimeChange() {
        let data = {
            id: this.id,
            examStartStatus: this.basicForm.startTimeState,
            examStartTime: this.basicForm.startTimeValue,
        }
        this.tipMessage = this.basicForm.startTimeState == 0 ? '取消设置' : '设置成功'
        await this.submitBasic(data)
    },
    async endTimeSwitch() {
        if (this.basicForm.endTimeState === 0) {
          this.basicForm.endTimeValue = ''
          let data = {
              id: this.id,
              examEndStatus: this.basicForm.endTimeState,
              examEndTime: this.basicForm.endTimeValue,
          }
          this.tipMessage = this.basicForm.endTimeState == 0 ? '取消设置' : '设置成功'
          await this.submitBasic(data)
        }
    },
    async endTimeChange() {
        let data = {
            id: this.id,
            examEndStatus: this.basicForm.endTimeState,
            examEndTime: this.basicForm.endTimeValue,
        }
        this.tipMessage = this.basicForm.endTimeState == 0 ? '取消设置' : '设置成功'
        await this.submitBasic(data)
    },
    async countDownChange(){
      if(this.basicForm.countDownState == 1 && this.basicForm.endTimeValue == '') {
          this.$message.error('请先设置考试结束时间')
          this.basicForm.countDownState = 0
      } else {
        let data = {
            id: this.id,
            openReverseTimeStatus: this.basicForm.countDownState,
        }
        this.tipMessage = this.basicForm.countDownState == 0 ? '取消设置' : '设置成功'
        await this.submitBasic(data)
      }
    },
    async overtimeSwitch() {
        if(this.basicForm.overtimeValue) {
          let data = {
              id: this.id,
              examrExceedTime: this.basicForm.overtimeValue,
              overtimeForceSubmit: this.basicForm.overtimeState
          }
          this.tipMessage = this.basicForm.overtimeState == 0 ? '取消设置' : '设置成功'
          await this.submitBasic(data)
        }
    },
    async overtimeBlur() {
        if (!this.basicForm.overtimeValue) {
            this.basicForm.overtimeState = 0
        }
        let data = {
            id: this.id,
            examrExceedTime: this.basicForm.overtimeValue,
            overtimeForceSubmit: this.basicForm.overtimeState
        }
        this.tipMessage = this.basicForm.overtimeState == 0 ? '取消设置' : '设置成功'
        await this.submitBasic(data)
    },
    async continueChange() {
        let data = {
            id: this.id,
            saveLastContent: this.basicForm.continueState
        }
        this.tipMessage = this.basicForm.continueState == 0 ? '取消设置' : '设置成功'
        await this.submitBasic(data)
    },
    async passwordChange() {
        let data = {
            id: this.id,
            answerPassword: this.basicForm.passwordValue,
            answerPasswordStatus: this.basicForm.passwordState
        }
        if (this.basicForm.passwordState === 0) {
            this.basicForm.passwordValue = ''
            this.$set(this.basicForm, 'passwordErr', false)
            this.tipMessage = this.basicForm.passwordState == 0 ? '取消设置' : '设置成功'
            await this.submitBasic(data)
        } else {
          this.$nextTick(() => {
            if (this.$refs.passwordVal) {
              const input = this.$refs.passwordVal.$el.querySelector('input')
              if (input) {
                input.focus()
              }
            }
          })
        }
    },
    async passwordBlur() {
        let data = {
            id: this.id,
            answerPassword: this.basicForm.passwordValue,
            answerPasswordStatus: this.basicForm.passwordState
        }
        if (this.basicForm.passwordValue) {
            this.$set(this.basicForm, 'passwordErr', false)
            this.tipMessage = this.basicForm.passwordState == 0 ? '取消设置' : '设置成功'
            await this.submitBasic(data)
        }else {
            // console.log('不能为空')
            this.$set(this.basicForm, 'passwordErr', true)
        }
    },
    // 基本设置 end

    // 提交后显示设置start
    submitSub(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectSubmitShow}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                    that.$message.success(that.tipMessage)
                } else{
                    that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    async reportCardChange() {
        let data = {
            id: this.id,
            showGradeBill: this.submitForm.reportCardState
        }
        this.tipMessage = this.submitForm.reportCardState == 0 ? '取消设置' : '设置成功'
        await this.submitSub(data)
    },
    async thankInfoChange() {
      let data = {
          id: this.id,
          showThankMessage: this.submitForm.thankInfoState,
          thanksContent: this.submitForm.thanksContent
      }
      this.tipMessage = this.submitForm.thankInfoState == 0 ? '取消设置' : '设置成功'
      await this.submitSub(data)
    },
    async thankInfoBlur() {
      if (!this.submitForm.thanksContent) {
          this.submitForm.thankInfoState = 0
      }
      let data = {
          id: this.id,
          showThankMessage: this.submitForm.thankInfoState,
          thanksContent: this.submitForm.thanksContent
      }
      this.tipMessage = this.submitForm.thankInfoState == 0 ? '取消设置' : '设置成功'
      await this.submitSub(data)
    },
    async rankingListChange() {
      let data = {
          id: this.id,
          showRanking: this.submitForm.rankingListState
      }
      this.tipMessage = this.submitForm.rankingListState == 0 ? '取消设置' : '设置成功'
      await this.submitSub(data)
    },
    async viewAnswersChange() {
      let data = {
          id: this.id,
          findResultParse: this.submitForm.viewAnswersState
      }
      this.tipMessage = this.submitForm.viewAnswersState == 0 ? '取消设置' : '设置成功'
      await this.submitSub(data)
        // console.log(this.submitForm.viewAnswersState)
    },
    // 提交后显示设置 end

    // 微信设置 start
    submitWX(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectWxInstall}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                    that.$message.success(that.tipMessage)
                } else{
                    that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    async onlyVXChange() {
        let data = {
            id: this.id,
            onlyWxAnswer: this.vxForm.onlyVXState
        }
        this.tipMessage = this.vxForm.onlyVXState == 0 ? '取消设置' : '设置成功'
        await this.submitWX(data)
        // console.log(this.vxForm.onlyVXState)
    },
    async getVXUsernameChange() {
        let data = {
            id: this.id,
            getWxName: this.vxForm.getVXUsernameState
        }
        this.tipMessage = this.vxForm.getVXUsernameState == 0 ? '取消设置' : '设置成功'
        await this.submitWX(data)
        // console.log(this.vxForm.getVXUsernameState)
    },
    async answerOnceChange() {
        if (this.vxForm.answerOnceState == 0) {
          this.vxForm.answerOnceValue = 0
          let data = {
              id: this.id,
              wxAnswerNum: this.vxForm.answerOnceValue,
              wxAnswerNumState: this.vxForm.answerOnceState
          }
          this.tipMessage = this.vxForm.answerOnceState == 0 ? '取消设置' : '设置成功'
          await this.submitWX(data)
        }
    },
    async answerOnceBlur() {
        if (!this.vxForm.answerOnceValue) {
            this.vxForm.answerOnceState = 0
        }
        let data = {
            id: this.id,
            wxAnswerNum: this.vxForm.answerOnceValue,
            wxAnswerNumState: this.vxForm.answerOnceState
        }
        this.tipMessage = this.vxForm.answerOnceState == 0 ? '取消设置' : '设置成功'
        await this.submitWX(data)
    },
    // 微信设置 end

    // 答题限制 start
    submitAnswer(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectAnswerSet}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                  that.$message.success(that.tipMessage)
                } else{
                  that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    async PCMTChange() {
        if (this.answerForm.PCMTState == 0) {
          this.answerForm.PCMTValue = 0
          let data = {
            id: this.id,
            pcPhoneAnswerNum: this.answerForm.PCMTValue,
            pcPhoneAnswerNumState: this.answerForm.PCMTState
          }
          this.tipMessage = this.answerForm.PCMTState == 0 ? '取消设置' : '设置成功'
          await this.submitAnswer(data)
        }
        // console.log(this.answerForm.PCMTValue)
    },
    async PCMTBlur() {
        if (!this.answerForm.PCMTValue) {
            this.answerForm.PCMTState = 0
        }
        let data = {
          id: this.id,
          pcPhoneAnswerNum: this.answerForm.PCMTValue,
          pcPhoneAnswerNumState: this.answerForm.PCMTState
        }
        this.tipMessage = this.answerForm.PCMTState == 0 ? '取消设置' : '设置成功'
        await this.submitAnswer(data)
    },
    async IPChange() {
      if (this.answerForm.IPState == 0) {
        this.answerForm.IPValue = 0
        let data = {
          id: this.id,
          ipRestrictNum: this.answerForm.IPValue,
          ipRestrictNumState: this.answerForm.IPState
        }
        this.tipMessage = this.answerForm.IPState == 0 ? '取消设置' : '设置成功'
        await this.submitAnswer(data)
      }
        // console.log(this.answerForm.IPValue)
    },
    async IPBlur() {
      if (!this.answerForm.IPValue) {
            this.answerForm.IPState = 0
        }
        let data = {
          id: this.id,
          ipRestrictNum: this.answerForm.IPValue,
          ipRestrictNumState: this.answerForm.IPState
        }
        this.tipMessage = this.answerForm.IPState == 0 ? '取消设置' : '设置成功'
        await this.submitAnswer(data)
    },
    async previewChange() {
      let data = {
        id: this.id,
        allowBeforePreview: this.answerForm.previewState
      }
      this.tipMessage = this.answerForm.previewState == 0 ? '取消设置' : '设置成功'
      await this.submitAnswer(data)
      // console.log(this.answerForm.previewState)
    },
    async subNumChange() {
      
      if (this.answerForm.subNumState == 0) {
          this.answerForm.subNum = 0
        let data = {
          id: this.id,
          setAnswerLimitState: this.answerForm.subNumState,
          setAnswerLimitNum: this.answerForm.subNum,
        }
        this.tipMessage = this.answerForm.subNumState == 0 ? '取消设置' : '设置成功'
        await this.submitAnswer(data)
      }
     
      // console.log(this.answerForm.subNumState)
    },
    async subNumBlur() {
      if (!this.answerForm.subNum) {
        this.answerForm.subNumState = 0
      }
      let data = {
        id: this.id,
        setAnswerLimitState: this.answerForm.subNumState,
        setAnswerLimitNum: this.answerForm.subNum,
      }
      this.tipMessage = this.answerForm.subNumState == 0 ? '取消设置' : '设置成功'
      await this.submitAnswer(data)
    },
    async hideInfoChange() {
      let data = {
        id: this.id,
        hideInfo: this.answerForm.hideInfoState
      }
      this.tipMessage = this.answerForm.hideInfoState == 0 ? '取消设置' : '设置成功'
      await this.submitAnswer(data)
      // console.log(this.answerForm.hideInfoState)
    },
    // 答题限制 end

    // 题目设置 start
    submitTopics(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectTitleInstall}?${data}`,
            method: "POST",
            cb(res) {
                if (res.code == 0) {
                  that.$message.success(that.tipMessage)
                } else{
                  that.$message.error('设置失败')
                }
            },
        };
        this.$util.request(params);
    },
    async topicsChange() {
      let data = qs.stringify({
        "id": this.id,
        "showTitleNum": this.topicsForm.serialNumState
      })
      this.tipMessage = this.topicsForm.serialNumState == 0 ? '取消设置' : '设置成功'
      await this.submitTopics(data)
      // console.log(this.topicsForm.serialNumState)
    },
    // 题目设置 end

    // 答题页显示设置 start
    submitIsShow(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectAnswerPageShowInstall}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                  that.$message.success(that.tipMessage)
                } else{
                  that.$message.error('设置失败')
                }
            },
        };
        this.$util.request(params);
    },
    // async languageChange(e) {
    //   // 0不开启  1 中文  2英文
    //   let data = {
    //     id: this.id,
    //     language: 0
    //   }
    //   if (this.isShowForm.languageState == 0) {
    //     data.language = 0
    //     await this.submitIsShow(data)
    //   } else if (this.isShowForm.languageState && this.isShowForm.languageValue){
    //     data.language = this.isShowForm.languageValue
    //     await this.submitIsShow(data)
    //   }
      
    //   // console.log(this.isShowForm.languageValue)
    // },
    async isShowProgressChange() {
      let data = {
        id: this.id,
        showSchedule: this.isShowForm.isShowProgressState
      }
      this.tipMessage = this.isShowForm.isShowProgressState == 0 ? '取消设置' : '设置成功'
      await this.submitIsShow(data)
      // console.log(this.isShowForm.isShowProgressState)
    },
    async newPageChange() {
      let data = {
        id: this.id,
        ifNewAnswerPage: this.isShowForm.newPageState
      }
      this.tipMessage = this.isShowForm.newPageState == 0 ? '取消设置' : '设置成功'
      await this.submitIsShow(data)
        // console.log(this.isShowForm.newPageState)
    },
    // 答题页显示设置 end

    // 分享设置 start
    submitShare(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectShareInstall}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                  that.$message.success(that.tipMessage)
                } else{
                  that.$message.error('设置失败')
                }
            },
        };
        this.$util.request(params);
    },
    async shareTemplateChange() {
      let data = {
        id: this.id,
        shareTemplate: this.shareForm.shareTemplateState
      }
      this.tipMessage = this.shareForm.shareTemplateState == 0 ? '取消设置' : '设置成功'
      await this.submitShare(data)
      
        // console.log(this.shareForm.shareTemplateState)
    },
    async queryChange() {
      let data = {
        id: this.id,
        externalFind: this.shareForm.queryState
      }
      this.tipMessage = this.shareForm.queryState == 0 ? '取消设置' : '设置成功'
      await this.submitShare(data)
      // console.log(this.shareForm.queryState)
    },
    async analysisChange() {
      let data = {
        id: this.id,
        countAnalyse: this.shareForm.analysisState
      }
      this.tipMessage = this.shareForm.analysisState == 0 ? '取消设置' : '设置成功'
      await this.submitShare(data)
        // console.log(this.shareForm.analysisState)
    },
    async contentSubmit() {
      let data = {
        id: this.id,
        questionnairePower: this.shareForm.copyValue,
        searchPower: this.shareForm.detectionValue
      }
      await this.submitShare(data)
        // console.log(this.shareForm.copyValue)
        // console.log(this.shareForm.detectionValue)
    },
    // 分享设置 end

    // 防作弊设置 start
    submitAntiCheating(data) {
        let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectStopCheatInstall}`,
            method: "POST",
            data: data,
            cb(res) {
                if (res.code == 0) {
                    that.$message.success(that.tipMessage)
                } else{
                    that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    submitRandom(data) {
      // console.log(data)
      let that = this
        let params = {
            that: this,
            url: `${this.$config.service.examProjectStopCheatRandom}`,
            method: "POST",
            data: data,
            cb(res) {
              // console.log(res)
                if (res.code == 0) {
                    that.$message.success('设置成功');
                } else{
                    that.$message.error('设置失败');
                }
            },
        };
        this.$util.request(params);
    },
    async randomChange() {
      if (this.antiCheatingForm.randomState == 1) {
        this.randomDialogVisible = true
      }

      this.$set(this.antiCheatingForm, 'randomValue', 1)
      if (this.antiCheatingForm.quesArr.length == 0) {
        this.$set(this.antiCheatingForm, 'quesArr', [{
          beginQid: '',
          endQid: '',
          number: 0,
          max: 0,
          isError: false
        }])
      }
      
      let data = {
        id: this.id,
        questionRandomState: this.antiCheatingForm.randomState
      }
      this.tipMessage = this.antiCheatingForm.randomState == 0 ? '取消设置' : '设置成功'
      await this.submitAntiCheating(data)
    },

    async rearrangeChange() {
      let data = {
        id: this.id,
        titleRealign: this.antiCheatingForm.rearrangeState
      }
      this.tipMessage = this.antiCheatingForm.rearrangeState == 0 ? '取消设置' : '设置成功'
      await this.submitAntiCheating(data)
        // console.log(this.antiCheatingForm.rearrangeState)
    },
    async whiteListChange() {
      if (this.antiCheatingForm.whiteListState == 0) {
        this.antiCheatingForm.whiteListValue = ''
        let data = {
          id: this.id,
          ipWhitelistStopCheat: this.antiCheatingForm.whiteListState,
          whiteListValue: this.antiCheatingForm.whiteListValue
        }
        this.tipMessage = this.antiCheatingForm.whiteListState == 0 ? '取消设置' : '设置成功'
        await this.submitAntiCheating(data)
      }
    },
    async whiteListBlur() {
      let whiteListValue
      if(this.antiCheatingForm.whiteListValue == '') {
        this.antiCheatingForm.whiteListState = 0
      } else {
        if (!this.antiCheatingForm.whiteListValue) {
          this.antiCheatingForm.whiteListState = 0
        }else if (this.antiCheatingForm.whiteListValue) {
          whiteListValue = this.antiCheatingForm.whiteListValue.replace(/\r+|\n+/g, ',')
        }
      }
      // console.log(whiteListValue)
      let data = {
        id: this.id,
        ipWhitelistStopCheat: this.antiCheatingForm.whiteListState,
        whiteListValue: whiteListValue
      }
      this.tipMessage = this.antiCheatingForm.whiteListState == 0 ? '取消设置' : '设置成功'
      await this.submitAntiCheating(data)

    },
    async timeoutChange() {
      if (this.antiCheatingForm.timeoutState == 0) {
        this.antiCheatingForm.timeoutValue = 0
        let data = {
          id: this.id,
          answerExceedState: this.antiCheatingForm.timeoutState,
          answerExceedTime: this.antiCheatingForm.timeoutValue
        }
        this.tipMessage = this.antiCheatingForm.timeoutState == 0 ? '取消设置' : '设置成功'
        await this.submitAntiCheating(data)
      }
        // console.log(this.antiCheatingForm.timeoutState)
    },
    async timeoutBlur() {
      if (!this.antiCheatingForm.timeoutValue) {
          this.antiCheatingForm.timeoutState = 0
        }
        let data = {
          id: this.id,
          answerExceedState: this.antiCheatingForm.timeoutState,
          answerExceedTime: this.antiCheatingForm.timeoutValue
        }
        this.tipMessage = this.antiCheatingForm.timeoutState == 0 ? '取消设置' : '设置成功'
        await this.submitAntiCheating(data)
    },
    async cutScreenChange() {
      if (this.antiCheatingForm.cutScreenState == 0) {
        this.antiCheatingForm.cutScreenValue = 0
        let data = {
          id: this.id,
          cutScreenStatus: this.antiCheatingForm.cutScreenState,
          cutScreenNum: this.antiCheatingForm.cutScreenValue
        }
        this.tipMessage = this.antiCheatingForm.cutScreenState == 0 ? '取消设置' : '设置成功'
        await this.submitAntiCheating(data)
      }
      // console.log(this.antiCheatingForm.cutScreenValue)
    },
    async cutScreenBlur() {
      if (!this.antiCheatingForm.cutScreenValue) {
            this.antiCheatingForm.cutScreenState = 0
        }
        let data = {
          id: this.id,
          cutScreenStatus: this.antiCheatingForm.cutScreenState,
          cutScreenNum: this.antiCheatingForm.cutScreenValue
        }
        this.tipMessage = this.antiCheatingForm.cutScreenState == 0 ? '取消设置' : '设置成功'
        await this.submitAntiCheating(data)
    },
    // 防作弊设置 end
  },
};
</script>

<style scoped lang="scss">
.outline-none{
  display: inline-block;
  outline: none;
}
.answer_set_ul {
  background: #FAFAFA;
}
.input_box{
    position: relative;
    // display: inline-block;
}
.tips{
  margin-top: 10px;
}
.max-btn{
  width: 100%;
  margin-top: 10px;
}
.submit-btn{
  margin: 10px auto 0 auto;
  display: block;
  padding: 9px 40px;
}
.thankTitle{
  background-color: rgba(242, 242, 242, 1);
  color: #169BD5;    
  font-size: 13px;
  line-height: 30px;
  padding: 0 10%;
}
/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/.el-input__inner[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
    -moz-appearance: textfield;
}

.form-item__error{
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
}

/deep/.input__err>.el-input__inner{
    border-color: #f56c6c;
}
.ques_title_box{
  margin: 10px 0;
  /deep/.el-input__inner{
      height: 28px;
    line-height: 28px;
  }
  /deep/.el-input__icon{
    line-height: 28px;
  }
  .list_title_item_input{
    margin: 0 5px;
    width: 130px;
  }
  .input_box{
    position: relative;
    .form-item__error{
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 27px;
        left: 6px;
    }
    }
    /deep/.input__err>.el-input__inner{
        border-color: #f56c6c;
    }
}

.list_title{
    display: flex;
    align-items: center;
}
.ques_title_box,.ques_page_box{
  display: flex;
  align-items: center;
  padding: 5px 10px;
  margin-top: 10px;
}
.ques_type_box{
  padding: 5px 10px;
  margin-top: 10px;
}
.ques_type_box{
 margin-bottom: 20px;
}
.list_title_item{
    display: flex;
    align-items: center;
    padding: 5px 10px;
    margin-left: 10px;
    background: rgba(240, 240, 240, 1);
    border-radius: 4px;
}
.list_title_item_input{
    margin: 0 5px;
    width: 90px;
}
.button_line {
  margin-left: 20px;
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e1e1e1;
  justify-content: space-between;
}
.button_line_box{
    display: flex;
    align-items: center;
}
.button_line_item {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
}
.limit_num {
  display: flex;
  align-items: center;
}
.limit_num_box {
  border-bottom: 1px solid #e1e1e1;
  background: #f7f8fa;
  padding: 20px 20px;
  margin-left: 10px;
}

.limit .limit_ys {
  width: 4px;
  height: 22px;
  border-left: #0080FF 4px solid;
  border-radius: 2px;
  margin-right: 7px;
  margin-left: 10px;
}
.limit > .limit_icon{
	position: absolute;
	top: 16px;
	right: 10px;
}
.limit > .limit_icon2{
	position: absolute;
	top: 16px;
	right: 28px;
}
.limit {
  height: 50px;
  line-height: 50px;
  font-family: MicrosoftYaHei;
  // font-size: 18px;
  color: #333;
  border-radius: 2px;
  background-color: #fff;
border-bottom: 1px solid #e1e1e1;
	position: relative;
}
.limit:hover{
	color: #0080FF;
}

.wx_limit_number .wx_limit_number_dt{
  font-size: 13px;
  width: 50px;
}
.wx_limit_number {
  display: flex;
  margin-left: 20px;
  height: 52px;
  align-items: center;
}
.wx_limit_number .el-input__inner {
  width: 60px;
  height: 24px;
  border: 1px solid #ccc !important;
}
.wx_limt .el-select .el-input__inner {
  width: 100px;
  height: 24px;
  line-height: 24px;
  border: 1px solid #ccc !important;
}
.wx_limt .el-select__caret {
  height: 24px;
  line-height: 24px;
}
.el-switch {
  margin-right: 20px;
}
.el-icon-arrow-right {
  margin-right: 20px;
}
.collection_method {
  height: auto;
  display: flex;
  margin-left: 20px;
  flex-direction: column;
}
.release-box{
  padding: 20px 0;
  text-align: center;
}
.delete-icon{
  font-size: 18px;
  display: inline-block;
  color: #ccc;
  margin-left: 10px;
  cursor: pointer;
}
/deep/.el-dialog{
  width: 860px !important;
}
</style>
